var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDepositIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 238,
    viewBox: "0 0 320 238",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160 237.13C248.366 237.13 320 207.382 320 170.685C320 133.988 248.366 104.24 160 104.24C71.6344 104.24 0 133.988 0 170.685C0 207.382 71.6344 237.13 160 237.13Z",
    fill: "url(#paint0_radial_398_6816)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M146.606 0L146.526 67.7554L221.419 110.879L221.286 43.1325L146.606 0Z",
    fill: "url(#paint1_linear_398_6816)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M146.526 66.588V124.238L221.384 167.45V109.836L146.526 66.588Z",
    fill: "#88E2A1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M134.103 6.14014L134.014 73.8955L208.916 117.019L208.774 49.2726L134.103 6.14014Z",
    fill: "url(#paint2_linear_398_6816)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M134.031 73.7886V131.429L208.889 174.642V117.037L134.031 73.7886Z",
    fill: "#C08FFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M121.635 13.3408L121.555 81.0872L196.449 124.211L196.306 56.4643L121.635 13.3408Z",
    fill: "url(#paint3_linear_398_6816)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M121.573 80.9981V138.639L196.422 181.851V124.237L121.573 80.9981Z",
    fill: "#8060EA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M109.168 21.085L109.088 88.8404L183.981 131.964L183.839 64.2175L109.168 21.085Z",
    fill: "url(#paint4_linear_398_6816)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M109.105 88.1898V145.83L183.955 189.043V131.438L109.105 88.1898Z",
    fill: "#570EE5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6114 95.3815V153.031L171.469 196.244V138.63L96.6114 95.3815Z",
    fill: "url(#paint5_linear_398_6816)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_398_6816",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(160.352 170.674) scale(159.77 66.4211)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#8060EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#8060EA",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#8060EA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_398_6816",
    x1: 167.753,
    y1: 82.4153,
    x2: 196.011,
    y2: 30.7937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#88E2A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#88E2A1",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#88E2A1",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#88E2A1",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#88E2A1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_398_6816",
    x1: 155.304,
    y1: 88.6081,
    x2: 183.561,
    y2: 36.9865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#C08FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#C08FFF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#C08FFF",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#C08FFF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#C08FFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_398_6816",
    x1: 142.89,
    y1: 95.8425,
    x2: 171.147,
    y2: 44.2209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#8060EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#8060EA",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#8060EA",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#8060EA",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#8060EA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_398_6816",
    x1: 130.476,
    y1: 103.638,
    x2: 158.733,
    y2: 52.0168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#570EE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#570EE5",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#570EE5",
    stopOpacity: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#570EE5",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#570EE5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_398_6816",
    x1: 100.328,
    y1: 155.393,
    x2: 169.019,
    y2: 135.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C08FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#A0BECA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88E2A1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepositIllustration);
export default __webpack_public_path__ + "static/media/deposit_illustration.0c6f8139f58887ffef0899bf62009857.svg";
export { ForwardRef as ReactComponent };